export default function Cta() {
  return (
    <section className="bg-primary-800">
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-6 px-4 py-10 text-center md:flex-row md:px-6 md:py-12 md:text-left">
        <div className="flex flex-col items-center gap-4 md:flex-row md:gap-5">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-accent-500 text-foreground-950 md:h-16 md:w-16">
            <i className="ri-bill-line text-2xl" />
          </span>
          <div>
            <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
              你有一手线索，想让我们做一期吗？
            </h2>
            <p className="mt-1.5 text-sm text-primary-100/90 md:text-base">
              投稿线索、商务合作、内容纠错，欢迎随时来信，编辑部会在核实后尽快回复。
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="mailto:bichidagua@example.com?subject=吃瓜线索投稿"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-800 transition hover:bg-accent-400 sm:w-auto"
          >
            <i className="ri-send-plane-line" /> 我要投稿线索
          </a>
          <a
            href="mailto:bichidagua@example.com?subject=商务合作"
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/50 px-6 py-3 text-sm font-semibold text-background-50 transition hover:border-background-50 hover:bg-background-50/10 sm:w-auto"
          >
            <i className="ri-briefcase-line" /> 商务合作
          </a>
        </div>
      </div>
    </section>
  );
}